var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.499991 6.49659L10.2929 6.49659L5.6464 11.143C5.4492 11.3362 5.44602 11.6528 5.63926 11.85C5.83255 12.0472 6.14908 12.0504 6.34628 11.8571C6.34866 11.8548 6.35104 11.8524 6.35342 11.85L11.8533 6.35005C12.0486 6.15499 12.0489 5.83871 11.8539 5.6434C11.8538 5.64321 11.8536 5.64309 11.8533 5.64309L6.35342 0.143175C6.15622 -0.0500593 5.83969 -0.0468855 5.64646 0.150316C5.45591 0.34471 5.45591 0.655802 5.64646 0.850196L10.2929 5.49661L0.499991 5.49661C0.223873 5.49661 -9.53674e-07 5.72048 -9.53674e-07 5.9966C-9.53674e-07 6.27272 0.223873 6.49659 0.499991 6.49659Z",
    fill: "#DF2935"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight3);
export default __webpack_public_path__ + "static/media/arrow_right_3.9d43e2de8dae99838c6fad0eee64127a.svg";
export { ForwardRef as ReactComponent };